import { render, staticRenderFns } from "./AlertSettings.page.vue?vue&type=template&id=7ca7cbef&scoped=true"
import script from "./AlertSettings.page.vue?vue&type=script&setup=true&lang=ts"
export * from "./AlertSettings.page.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./AlertSettings.page.vue?vue&type=style&index=0&id=7ca7cbef&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ca7cbef",
  null
  
)

export default component.exports